<template>
  <div>
    <Main ref="main" :tableData="tableData"> </Main>
  </div>
</template>
<script>
import Main from './main'
export default {
  components: { Main },
  props: {
    tableData: { type: Array, default: () => [] },
  },
}
</script>
